












































import Modal from '@/project/modals/Modal.vue';
import { Component, Prop } from 'vue-property-decorator';
import CategoryNavigation from '@/project/search/navigation/CategoryNavigation.vue';
import { FacetViewObject, MenuItem } from '@/types/apiServerContract';
import CategoryFacets from '@/project/search/facets/CategoryFacets.vue';
import MobileFacets from '@/project/search/facets/MobileFacets.vue';
import urlHelper from '@/core/urlHelper.service';
import Accordion from '@/core/ui-components/Accordion.vue';
import bus from '@/core/bus';
import { MobileFacetsUpdateEventKey } from '@/core/http/constants';

@Component({
    components: { MobileFacets, CategoryFacets, CategoryNavigation, Accordion }
})
export default class MobileNavigationAndFacets extends Modal {
    @Prop({ type: String, required: true })
    private contextKey!: string;

    @Prop({ type: Array })
    private readonly initialFacets!: FacetViewObject[] | null;

    @Prop({ type: Object })
    private readonly rootMenuItem!: MenuItem | null;

    @Prop({ type: Object })
    private activeMenuItem!: MenuItem | null;

    @Prop({ type: String, default: '' })
    private campaignCode!: string;

    @Prop({ type: Array })
    private menuItems!: MenuItem[];

    @Prop({ type: Boolean, default: false })
    private useFlattenedCategoryTree!: boolean;

    localFacets: FacetViewObject[] | null = null;

    created() {
        bus.on(MobileFacetsUpdateEventKey, this.facetsUpdatedEvent);
    }

    private beforeDestroy() {
        bus.off(MobileFacetsUpdateEventKey, this.facetsUpdatedEvent);
    }

    private facetsUpdatedEvent(updates) {
        if (updates.facets) {
            this.localFacets = updates.facets;
        }
    }

    private get facetsComputed() {
        return this.localFacets || this.initialFacets;
    }

    private resetFilters() {
        this.menuItems.forEach(x => x.selected = false);

        urlHelper.clearFacets();
        urlHelper.removeQueryParams('categoryIdsKey');
    }
}
